import React, { useEffect } from "react";
import { FaExternalLinkAlt, FaSpinner } from "react-icons/fa";

const DEFAULT_PORTAL_URL = "https://13.233.31.31:3000";

const getSecurePortalUrl = () => {
  const candidate = process.env.REACT_APP_PORTAL_URL || DEFAULT_PORTAL_URL;

  try {
    const parsed = new URL(candidate);
    return parsed.protocol === "https:" ? parsed.toString() : "";
  } catch {
    return "";
  }
};

const Portal = () => {
  const portalUrl = getSecurePortalUrl();

  useEffect(() => {
    if (!portalUrl) {
      return undefined;
    }

    // Redirect after showing loading message for better UX
    const timer = setTimeout(() => {
      window.location.assign(portalUrl);
    }, 2000);

    return () => clearTimeout(timer);
  }, [portalUrl]);

  const handleRedirectNow = () => {
    if (portalUrl) {
      window.location.assign(portalUrl);
    }
  };

  return (
    <div className="page-container portal-page">
      <section className="home-card portal-redirect-card">
        <div className="portal-redirect-content">
          <FaSpinner className="portal-loading-icon" />
          <h2 className="portal-redirect-title">Redirecting to Portal...</h2>
          <p className="portal-redirect-message">
            You will be redirected to our secure portal application in a moment.
          </p>
          <div className="portal-redirect-actions">
            <button 
              onClick={handleRedirectNow}
              className="portal-redirect-btn"
              disabled={!portalUrl}
            >
              <FaExternalLinkAlt className="portal-btn-icon" />
              Go to Portal Now
            </button>
          </div>
          <div className="portal-redirect-details">
            {portalUrl ? (
              <p>If you're not redirected automatically, please click the button above.</p>
            ) : (
              <p>Portal URL is not configured with HTTPS. Set REACT_APP_PORTAL_URL to a secure URL.</p>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portal;